/* eslint-disable */
import { cloneDeep } from 'lodash';
import { notificationServices } from '../../../Services';

const initialState = {
	name: '',
	sacCode: '',
	clientServiceCode: '', // Add this new field
	category: '',
	taxApplicable: '',
	image: null
  };

const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT':
      return initialState;
    case 'SET_NAME':
      return {
        ...state,
        name: action.payload
      };
    case 'SET_SAC_CODE':
      return {
        ...state,
        sacCode: action.payload
      };
    case 'SET_CATEGORY':
      return {
        ...state,
        category: action.payload
      };
    case 'SET_TAX_APPLICABLE':
      return {
        ...state,
        taxApplicable: action.payload
      };
    case 'SET_IMAGE':
      return {
        ...state,
        image: action.payload
      };
	case 'CLEAR_IMAGE':
		return {
			...state,
			image: null
		}
	case 'SET_CLIENT_SERVICE_CODE':
	return {
		...state,
		clientServiceCode: action.payload
	};
	case 'SET_EDIT_DATA':
		return {
			...state,
			name: action.payload.name || '',
			sacCode: action.payload.sacCode || '',
			clientServiceCode: action.payload.clientServiceCode || '', // Add this
			category: action.payload.category?.id || '',
			taxApplicable: action.payload.taxPercentage ?? '',
			image: action.payload.image || null,
		};
    default:
      return state;
  }
};

const mandatoryFields = {
  name: true,
  category: true,
};

const validator = (data) => {
  // Validate required fields
  if (!data?.name || data?.name?.trim().length === 0) {
    notificationServices.generateNotification({
      type: 'error',
      message: 'Service name is required',
    });
    return false;
  }

  if (!data?.category) {
    notificationServices.generateNotification({
      type: 'error',
      message: 'Category is required',
    });
    return false;
  }

  // Validate SAC code format if provided (example: 6-digit number)
  if (data.sacCode && !/^\d{6}$/.test(data.sacCode)) {
    notificationServices.generateNotification({
      type: 'error',
      message: 'SAC code must be a 6-digit number',
    });
    return false;
  }

  // Validate tax applicable format (example: percentage between 0 and 100)
  if (data.taxApplicable && (isNaN(data.taxApplicable) || 
      Number(data.taxApplicable) < 0 || 
      Number(data.taxApplicable) > 100)) {
    notificationServices.generateNotification({
      type: 'error',
      message: 'Tax applicable must be a percentage between 0 and 100',
    });
    return false;
  }

  // Validate image if required
  if (!data.image) {
    notificationServices.generateNotification({
      type: 'error',
      message: 'Product image is required',
    });
    return false;
  }

  return true;
};

// Update deserializer
const deserializer = (state) => {
	const clonedState = cloneDeep(state);
	
	const req = {
	  name: clonedState.name.trim(),
	  sacCode: clonedState.sacCode.trim(),
	  clientServiceCode: clonedState?.clientServiceCode?.trim(), // Add this
	  categoryId: clonedState.category,
	  taxPercentage: clonedState.taxApplicable ? Number(clonedState.taxApplicable) : 0,
	  image: clonedState.image
	};
  
	// Remove empty optional fields
	if (!req.sacCode) delete req.sacCode;
	if (!req.clientServiceCode) delete req.clientServiceCode;
	if (!req.taxApplicable) delete req.taxApplicable;
  
	return req;
  };

const config = {
  initialState,
  reducer,
  mandatoryFields,
  validator,
  deserializer,
};

export default config;